import QuestionCreator from '../questionCreator';
import TaskDetails from '../../../components/shared/TaskDetails';

import { IQuestionComponentProps } from '../types';

import { HISTORY_TYPE } from '../../../constants';
import MESSAGES from '../../../constants/message';

import imgMultiTasking from '/images/multitasking.svg';

const LifeStyleComponent: React.FC<IQuestionComponentProps> = ({
  isQuestionnaireComplete,
  questionnaires,
  toggleQuestionnaireCompletion,
  navigateToTasks,
}) => {
  if (isQuestionnaireComplete) {
    return (
      <TaskDetails
        title={MESSAGES.LIFESTYLE.TITLE}
        description={MESSAGES.LIFESTYLE.DESCRIPTION}
        buttonText={MESSAGES.LIFESTYLE.BUTTON_CONTINUE}
        imgSrc={imgMultiTasking}
        imgAlt="multitasking"
        imgWidth="259px"
        handleClick={toggleQuestionnaireCompletion}
        handleClose={navigateToTasks}
      />
    );
  }

  if (questionnaires)
    return (
      <QuestionCreator
        questionnaires={questionnaires}
        historyType={HISTORY_TYPE.LIFESTYLE}
      />
    );

  return null;
};

export default LifeStyleComponent;
